import styled from 'styled-components'

export const SvgPortfolio =styled.svg`
    width: 100%;
    height: 100vh;
    position:absolute;
`;

export const GrainyBackgroundContainer =styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    position:relative;
    z-index:-1;
    background: linear-gradient(
    135deg,
    #FFCADC 0%, /* Pink at bottom left */
    #C4AFCF 100% /* Purple at top right */
  );
`;